/** Par défaut : foyer résident fiscal portugais, prélèvement de solidarité à 7,5 %. */
export const DEFAULT_TAX_RESIDENCY = 'non-resident-eea';
/** Prélèvement de solidarité, seul dû par un non-résident affilié à l'EEE. */
export const SOLIDARITY_LEVY_RATE = 0.075;
/** CSG + CRDS + prélèvement de solidarité, dus dans tous les autres cas. */
export const SOCIAL_CONTRIBUTIONS_RATE = 0.172;
export function socialContributionRateFor(residency) {
    return residency === 'non-resident-eea' ? SOLIDARITY_LEVY_RATE : SOCIAL_CONTRIBUTIONS_RATE;
}
//# sourceMappingURL=residency.js.map